export function getFormattedPrice(
  value: any,
  options?: { prefix?: string; sufix?: string }
) {
  const { prefix, sufix } = options || {};
  return (
    (prefix ? prefix : '') +
    `$${Number(value).toLocaleString()}` +
    (sufix ? sufix : '')
  );
}
